module.exports = __webpack_public_path__ + "images/Redundancy.6445ade0d24fbf66455013d529a5d2f4.svg";